// src/iTwin/export/ifc/psets/featurePset.ts
import type { Feature } from "../../../../domain/utilities/Feature";
import type { NextId } from "../core/step";
import { ifcText, writePropertySetForElement, type IfcProp } from "../core/step";

function asTrimmedString(v: unknown): string {
  if (v === null || v === undefined) return "";
  return String(v).trim();
}

function addText(props: IfcProp[], name: string, v: unknown): void {
  const s = asTrimmedString(v);
  if (!s) return;
  props.push({ name, value: ifcText(s) });
}

function resolveFeatureDefinition(feature?: Feature, featureDefinitionOverride?: unknown): string {
  const override = asTrimmedString(featureDefinitionOverride);
  if (override) return override;
  return asTrimmedString((feature as any)?.FeatureDefinition);
}

function hasMeaningfulFeature(feature?: Feature, featureDefinitionOverride?: unknown): boolean {
  return (
    resolveFeatureDefinition(feature, featureDefinitionOverride).length > 0 ||
    asTrimmedString((feature as any)?.Name).length > 0
  );
}

function buildFeatureProps(feature: Feature | undefined, featureDefinitionOverride?: unknown): IfcProp[] {
  const props: IfcProp[] = [];
  const f = feature as any;

  addText(props, "Feature Definition", resolveFeatureDefinition(feature, featureDefinitionOverride));
  addText(props, "Feature Name", f?.Name);

  return props;
}

export function writeFeaturePset(args: {
  getNextId: NextId;
  ownerHistoryId: number;
  elementId: number;
  feature?: Feature;
  featureDefinitionOverride?: unknown;
}): string {
  const { getNextId, ownerHistoryId, elementId, feature, featureDefinitionOverride } = args;

  if (!hasMeaningfulFeature(feature, featureDefinitionOverride)) return "";

  return writePropertySetForElement({
    getNextId,
    ownerHistoryId,
    elementId,
    psetName: "Feature",
    props: buildFeatureProps(feature, featureDefinitionOverride),
  });
}
